import type { components } from '@front/generated/apiClient';
import type { CsvAnalysis } from 'troppus-common/shared';

type Api = components['schemas']['CsvAnalysis'];

export const fromApi = (dto: Api): CsvAnalysis => ({
  fileId: dto.fileId,
  detectedEncoding: dto.detectedEncoding,
  detectedDelimiter: dto.detectedDelimiter,
  hasHeaderRow: dto.hasHeaderRow,
  columns: dto.columns.map((column) => ({
    name: column.name,
    inferredType: column.inferredType,
    inferredDestination: column.inferredDestination,
    inferredTransformRules: column.inferredTransformRules,
    sampleValues: column.sampleValues,
    confidence: column.confidence,
  })),
  uniqueKeysDraft: {
    customer: dto.uniqueKeysDraft.customer,
    contract: dto.uniqueKeysDraft.contract,
  },
  rowCountEstimate: dto.rowCountEstimate,
  llm:
    dto.llm === undefined
      ? undefined
      : {
          modelId: dto.llm.modelId,
          durationMs: dto.llm.durationMs,
          usage: {
            promptTokens: dto.llm.usage.promptTokens,
            completionTokens: dto.llm.usage.completionTokens,
            totalTokens: dto.llm.usage.totalTokens,
          },
        },
});
